import type { MessageHandlerDeps } from '../message-handler-deps.js';
import type { ApiToBridgeMessage } from '../../types/api-to-bridge-messages.js';
import {
  handleFileBrowserRequestMessage,
  handleFileBrowserSearchMessage,
} from '../handlers/file-browser-messages.js';
import { handleFileBrowserCodeNavMessage } from '../handlers/code-nav-messages.js';
import {
  handleBridgeGitContextRequestMessage,
  handleListRepoBranchesRequestMessage,
} from '../handlers/bridge-git-context-messages.js';

export function dispatchBridgeFileBrowserMessage(
  msg: Extract<
    ApiToBridgeMessage,
    {
      type:
        | 'file_browser_request'
        | 'file_browser_search'
        | 'code_nav'
        | 'bridge_git_context_request'
        | 'list_repo_branches_request';
    }
  >,
  deps: MessageHandlerDeps
): void {
  switch (msg.type) {
    case 'file_browser_request':
      handleFileBrowserRequestMessage(msg, deps);
      break;
    case 'file_browser_search':
      handleFileBrowserSearchMessage(msg, deps);
      break;
    case 'code_nav':
      handleFileBrowserCodeNavMessage(msg, deps);
      break;
    case 'bridge_git_context_request':
      handleBridgeGitContextRequestMessage(msg, deps.getWs);
      break;
    case 'list_repo_branches_request':
      handleListRepoBranchesRequestMessage(msg, deps.getWs);
      break;
  }
}
